import { installAppApi } from './install-app-api/installAppApi';

window.__INSTALL_APP__ = installAppApi;
